import React, { useEffect, useState } from 'react';
import MetaMaskOnboarding from '@metamask/onboarding'
import { Link, useLoaderData, useLocation, useNavigate } from "react-router-dom";
import Logo from '../assets/Logo.png';
// import web3 from 'web3'

import './Style.css';
import { errorPopup, successPopup } from '../utils/PopUpMessage';
import { Button } from 'bootstrap';
import { ethers } from 'ethers';
// import Footer from './Footer';

export default function Header(props) {
  const [userConnected, setUserConnected] = useState(false);
  const [accountAddress, setAccountAddress] = useState("");
  const [walletConnected, setWalletConnected] = useState("");
  const [hide, setHide] = useState(true);



  const navigate = useNavigate();
  const onboarding = new MetaMaskOnboarding();

  let metamaskAccounts;
  const getMetamaskAccount = async () => {
    try {
      metamaskAccounts = await window?.ethereum?.request({
        method: "eth_requestAccounts",
      });
      console.log(metamaskAccounts, "Metamask Account");
      if (window?.ethereum?.networkVersion == '5' || window?.ethereum?.networkVersion == '69' ||
        window?.ethereum?.networkVersion == '80001' || window?.ethereum?.networkVersion == '137'
        || window?.ethereum?.networkVersion == '1' || window?.ethereum?.networkVersion == '56' || window?.ethereum?.networkVersion == '97') {
        return metamaskAccounts[0]

      } else {
        errorPopup("Please Connect to Correct Network")
        throw "Connect to Correct Network"
      }
      // let balance = await window.ethereum.metaMask.getBalanceOf(metamaskAccounts[0])
      // console.log(balance, "metamask");
    } catch (error) {
      console.error(error, "hi")
      // eslint-disable-next-line
      if (error.code == -32002) {
        errorPopup('Please Manually connnect to metamask')
      }
    }
  }

  const ProvidermetamaskLogin = async () => {
    // eslint-disable-next-line
    if (window?.ethereum == undefined) {
      onboarding.startOnboarding();

      return window.alert('Download Metamask Wallet Extension');
    }
    if (window?.ethereum?.networkVersion === props.network) {
      console.log(props.network)

    }
    // eslint-disable-next-line
    if (typeof window?.ethereum !== "undefined") {
      getMetamaskAccount().then(async (response) => {
        if (response) {
          // setMetamaskAccountAddress(response);
          setUserConnected(true);
          setAccountAddress(response);
          console.log(response)
          setWalletConnected("Metamask Wallet");
          localStorage.setItem("walletAddr", metamaskAccounts)
          localStorage.setItem('wallet', "METAMASK");
          localStorage.setItem('address', response);
          successPopup("Wallet Connected")

          // navigate("/service-profile")
        }
        props.confirmbutton(false);

      });
    }
    // else if (typeof window?.ethereum !== "undefined" && (window?.ethereum?.networkVersion !== "5" || window?.ethereum?.networkVersion !== '69')) {
    //   errorPopup('Change Network To Kovan Or Arbitrum Ethereum.')
    // } 
    else {
      errorPopup("Please Add Metamask Wallet")
    }

  }
  const disconnectUser = async () => {
    setAccountAddress('');
    setUserConnected(false);
    setWalletConnected("");
    localStorage.removeItem("walletAddr")
    localStorage.removeItem('wallet');
    successPopup("Disconnected wallet")
    props.confirmbutton(true)


  }
   

  useEffect(() => {
    if (localStorage.getItem('walletAddr')) {
      setUserConnected(true);
      setAccountAddress(localStorage.getItem('walletAddr'))
    } else if (localStorage.removeItem("walletAddr")) {
      setUserConnected(false);
      setAccountAddress(localStorage.removeItem("walletAddr"));


    }
  }, [])

  const location = useLocation();
  console.log(location);
  useEffect(() => {

    if (location.pathname == '/') {
      document.getElementById('connectBtn').style.cssText = 'display : none'
    }


    else {
      document.getElementById('connectBtn').style.cssText = 'display: block'

    }
  }, [location])

 

  return (
    <>
      <header className="header navbar-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg">
                <div class="logo">
                  <img src={Logo} width="60px" heigth="60px" alt="logo" />
                </div>
                <Link to="/" className="navbar-brand " style={{ fontSize: "2rem", fontFamily: "Poppins, Helvetica Neue, Arial, sans-serif;", fontWeight: "500" }}>Tokenmaker</Link>
                <div className="ms-auto d-none d-lg-block" >
                  <span id='connectBtn'>

                    {
                      userConnected && accountAddress ?
                        <button className="btn btn-action rounded-pill btn-rounded btn-pad bg-danger text-light"
                          onClick={disconnectUser}

                        >
                          {` ${accountAddress.substring(0, 10)}...Disconnect`}</button>

                        :
                        <button className="btn btn-action rounded-pill btn-rounded btn-pad bg-danger text-light" onClick={ProvidermetamaskLogin}>Connect Wallet</button>

                    }
                  </span>

                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}









